import { render, staticRenderFns } from "./ProjectsSection.vue?vue&type=template&id=66525617&scoped=true&"
import script from "./ProjectsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsSection.vue?vue&type=style&index=0&id=66525617&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66525617",
  null
  
)

export default component.exports